module.exports = __webpack_public_path__ + "img/cr.9c0e7a1.svg";